/*
创建者 魏强(2018.1.23)
*/
<template>
  <div class="wrapper maxwidth">
    <Carousel v-show="isShow" id="top-ad-carousel" v-model="value" :autoplay="setting.autoplay"
      :autoplay-speed="setting.autoplaySpeed" :dots="setting.dots" :radius-dot="setting.radiusDot"
      :trigger="setting.trigger" :arrow="setting.arrow">
      <CarouselItem v-for="(item,index) in list " :key="index">
        <router-link :to="item.to" :title="item.aname">
          <img :src="item.atturl" :alt="item.aname" height="80px" width="100%" />
        </router-link>
      </CarouselItem>

    </Carousel>
  </div>
</template>
<script>
import { pcTopAdv } from 'api/home';
import { parseAdvList } from 'utils/tool';
export default {
  data() {
    return {
      value: 0,
      isShow: true,
      setting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'inside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'never'
      },
      list: []
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      pcTopAdv().then(json => {
        if (json.resCode == 1) {
          let data = json.data;
          if (!data.advInfoList[0]) {
            this.isShow = false;
            return;
          }
          this.list = parseAdvList(data.advInfoList[0].advList);

        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// top-ad.vue?70f0608d